module.exports = __webpack_public_path__ + "img/ph.6d05ba20.svg";